// extracted by mini-css-extract-plugin
export default {"wrapper":"tea","container":"uea","title":"vea","carousel":"wea","review":"xea","name":"yea","rating":"zea","heading":"Aea","body":"Bea"};
    if(module.hot) {
      // 1737143665390
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  